<template>
  <div>
    <div class="satmed-bg pt-5 pb-2">
      <b-container>
        <b-row>
          <b-col class="mt-4 mt-md-0 text-center" cols="12" sm="12" md="4">
            <b-img
            :src="require('@/assets/images/logo.svg')"
            fluid
            alt="Alcaldía de Medellín"
            ></b-img>
          </b-col>
          <b-col class="mt-4 mt-md-0 text-center" cols="12" sm="12" md="2">
            <p><b>Un proyecto de</b></p>
            <p>Secretaría de la Juventud</p>
          </b-col>
          <b-col class="mt-4 mt-md-0 text-left" cols="6" sm="6" md="3">
            <p><b>Contacto</b></p>
            <p><b>Teléfono:</b><br>+57 (4) 444 4144</p>
            <p><b>Dirección:</b><br>
              Secretaría de la Juventud <br>
              Carrera 53A @ 42 - 101. Edificio plaza
              de la Libertad. Torre B. Piso 10
            </p>
          </b-col>
          <b-col class="mt-4 mt-md-0 text-left" cols="6" sm="6" md="3">
            <p><b>Aliados</b></p>
            <a href="https://www.icbf.gov.co/" target="_blank">ICBF</a><br>
            <a href="http://www.inder.gov.co/" target="_blank">INDER</a><br>
            <a href="http://arrobamedellin.edu.co/" target="_blank">@medellin</a><br>
            <a href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=navurl://cb03c5f8a3bc78e29b5d3b6db158745f"
              target="_blank">Secretaría de Inclusión Social, Familia y Derechos Humanos</a><br>
            <a href="http://medellin.edu.co/"
              target="_blank">Secretaría de Educacion</a><br>
            <a href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=navurl://10a75d24d37a79009a056c48a495a8fb"
              target="_blank">Secretaría de Salud</a><br>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="p-3">
      <p>
          <a target="_blank" href="http://satmed.co/quienes-somos/">Conócenos</a> -
          <a target="_blank" href="http://satmed.co/contacto/">Contáctenos</a> -
          <a target="_blank" href="http://satmed.co/politica-datos/">Política de datos</a> -
          <a target="_blank" href="https://satmed.co/cookies/">Política de cookies</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
};
</script>

<style scoped>
.satmed-bg{
  background-color: #efad19;
  font-size: 0.8rem;
}
</style>
